"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("../../../components");

exports.StrengthsSectionImage = styled_components_1.default(components_1.OwlImage)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-left: 0;\n    margin-bottom: 0;\n    margin-top: 80px;\n"], ["\n    margin-left: 0;\n    margin-bottom: 0;\n    margin-top: 80px;\n"])));
var templateObject_1;